import { useMutation } from '@tanstack/react-query';
import { ApiError, apiClient } from 'shared/api';

import { loginResponseType } from './authSchema';

const postLogin = async ({ email, password }: { email: string; password: string }): Promise<loginResponseType> => {
  const { data } = await apiClient.post('/auth/member/login', { email, password });

  // NOTE: 현재 실패한 요청에도 http code를 200으로 받고 있기 때문에 아래와 같이 처리합니다
  if (!data.isSuccess) {
    throw new ApiError(data);
  }

  return data.result;
};

export const usePostLogin = ({
  onSuccess,
  onError,
}: {
  onSuccess: (data: loginResponseType) => void;
  onError: (error: string) => void;
}) => {
  return useMutation({
    mutationFn: postLogin,

    onSuccess: (data) => {
      onSuccess && onSuccess(data);
    },

    onError: (error) => {
      if (error instanceof ApiError) {
        onError && onError(error.message);
      }
    },
  });
};
